class DropdownDisclosure extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    const summaryElement = this.querySelector('summary');
    const detailsElement = summaryElement?.closest('details');
    summaryElement?.addEventListener(
      'click',
      this.onSummaryClick.bind(this),
    );

    detailsElement?.addEventListener('toggle', () => {
      summaryElement.setAttribute('aria-expanded', detailsElement.open);
    });

    detailsElement?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && detailsElement.open) {
        this.close(event, summaryElement, detailsElement);
        summaryElement.focus();
      }
    });

    this.querySelector('label')?.addEventListener('click', () => {
      const summaryElement = this.querySelector('details summary');

      summaryElement?.click();
    })
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    isOpen
      ? this.close(event, summaryElement, detailsElement)
      : this.open(summaryElement, detailsElement);
  }

  open(summaryElement, detailsElement) {
    setTimeout(() => {
      detailsElement.classList.add('is-open');
    });
    summaryElement.setAttribute('aria-expanded', true);
  }

  close(event, summaryElement, detailsElement) {
    if (event === undefined) return;
    event.preventDefault();

    detailsElement.classList.remove('is-open');
    detailsElement.removeAttribute('open');
    summaryElement.setAttribute('aria-expanded', false);
  }
}

customElements.define('dropdown-disclosure', DropdownDisclosure);
